export const SET_USER_MENU_DETAILS = 'SET_USER_MENU_DETAILS';
export const REMOVE_USER_MENU_DETAILS = 'REMOVE_USER_MENU_DETAILS';